import { render } from "./HeroiconsSolidPhoneMissedCall.vue?vue&type=template&id=3ee24e97"
const script = {}

import exportComponent from "/home/omid_es327/Projects/erp/laravel/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidPhoneMissedCall.vue"]])

export default __exports__